define('views/modules/dashboard/dashboard',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // Views
    'src/views/responsive-view',
    'views/modules/dashboard/dashboard-header',
    'views/modules/dashboard/graph/graph',
    'views/modules/dashboard/goal/goal',
    'views/modules/forum/summary/forum-summary',
    'views/modules/member/supervisors/supervisors',
    'views/modules/calendar/calendar/calendar-component/item/calendar-item-add-list',
    'views/modules/member/supervisors/new-messages',
    'views/modules/dashboard/activities/activities',
    'views/modules/stats/week-stats',
    // Templates
    'text!templates/modules/dashboard/dashboard.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // Views
    VResponsive,
    VDashboardHeader,
    VDashboardGraph,
    VDashboardGoal,
    VForumSummary,
    VMemberSupervisors,
    VCalendarItemAddList,
    VNewMessages,
    VActivities,
    VWeekStats,
    // Templates
    TDashboard
) {

    var VDashboard = VResponsive.extend({
        template: TDashboard,

        regions: {
            header: "#header",
            goal: ".goal",
            graph: ".graph",
            forum: ".forum",
            supervisors: '#my-coach',
            messages: '#my-coach-messages',
            activities: '#activities',
            stats: '.stats'
        },

        initialize: function(opt) {
            opt = opt || {};

            var url = opt.url,
                model = this.model,
                view = this.view = {
                    header: new VDashboardHeader({
                        title: 'Dashboard',
                        subtitle: 'Welcome to Totalcoaching!',
                        skipTranslation: true,
                        profile: model
                    }),
                    graph: new VDashboardGraph({
                        model: model,
                        url: url.graph
                    }),
                    supervisors: new VMemberSupervisors({
                        model: model,
                        url: url.message,
                        group: opt.group,
                    }),
                    messages: new VNewMessages({
                        model: model,
                        url: url.message
                    }),
                    activities: new VActivities({
                        model: model,
                        url: url,
                        role: opt.role
                    }),
                    goal: new VDashboardGoal({
                        model: model,
                        url: url,
                        group: opt.group,
                    }),
                    forum: new VForumSummary({
                        model: model,
                        url: url.forum
                    }),
                    stats: new VWeekStats({
                        model: model
                    })
                };

            this.listenTo(this.getNewConversations(), {
                'sync': this.onConversationsSync,
                'reset': this.onConversationsReset
            });
            this.listenTo(model, { 'sync': this.onModelSync });
            this.listenTo(this.view.activities, { 'dashboard.activity:update': this.setDashboardWeeklyStat });
        },

        render: function() {

            this.view.stats.collection.reset();

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.goal, zone.$goal)
                .assign(view.header, zone.$header)
                .assign(view.graph, zone.$graph)
                .assign(view.messages, zone.$messages)
                .assign(view.supervisors, zone.$supervisors)
                .assign(view.activities, zone.$activities)
                .assign(view.stats, zone.$stats)
                .assign(view.forum, zone.$forum);

            return this;
        },

        getNewConversations: function() {
            return this.view.messages.getConversations();
        },

        toggleSupervisor: function(val) {
            this.view.supervisors.toggle(val);
        },

        setDashboardWeeklyStat: function() {
          this.view.stats.render();
        },

        onResize: function(e, width) {
            var view = this.view.graph;
            if (view.onResize) {
                view.onResize(e, width);
            }
        },

        onConversationsSync: function(collection) {
            this.toggleSupervisor(!Boolean(collection.length));
        },

        onConversationsReset: function(collection) {
            var hasMessages = Boolean(collection.length);
            this.toggleSupervisor(!hasMessages);
            this.view.messages.toggle(hasMessages);
        },
    });

    return VDashboard;

});

